import { FileAPIEntry, FileAction, FileState } from 'components/common/FileAPI'

/**
 * An entry is delivered once its upload or re-upload succeeded. The thumbnail LOAD that follows may
 * fail without touching the bytes in GCS, so LOAD entries count whatever their state — a cancelled
 * LOAD included, since cancelling a thumbnail fetch does not remove the object. INIT entries (the
 * `createFileAPIEntry` default, before any action has run) and entries mid-DELETE never count.
 */
export const isDeliveredVisual = (entry: FileAPIEntry): boolean =>
  entry.action === FileAction.LOAD ||
  ((entry.action === FileAction.UPLOAD || entry.action === FileAction.RE_UPLOAD) && entry.state === FileState.SUCCESS)

/** An upload that settled without reaching GCS; its tile stays on screen until the creative retries or deletes it */
export const isFailedUpload = (entry: FileAPIEntry): boolean =>
  (entry.action === FileAction.UPLOAD || entry.action === FileAction.RE_UPLOAD) && (entry.state === FileState.ERROR || entry.state === FileState.CANCELLED)
